<app-header (onHamburgerClicked)="collapseSidebar()"></app-header>
<mat-drawer-container class="page">

  <!-- Sidebar -->
  <mat-drawer #sidebar class="sidebar" [class.collapsed]="collapsedSidebar" mode="side" opened>

    <!-- Sidebar elements -->
    <app-sidebar-element *ngIf="accountManagerService.isAdminOrExpert()" [collapsed]="collapsedSidebar" title="Equipments" icon="widgets" [selected]="isSelected('equipment')" (click)="goToPage('equipment')"></app-sidebar-element>
    <!--<app-sidebar-element title="Dashboard" [collapsed]="collapsedSidebar" icon="dashboard" [selected]="isSelected('dashboard')" (click)="goToPage('dashboard')"></app-sidebar-element>-->
    <app-sidebar-element *ngIf="accountManagerService.isAdminOrExpert()" [collapsed]="collapsedSidebar" title="Field services" icon="domain" [selected]="isSelected('field-service')" (click)="goToPage('field-service')"></app-sidebar-element>
    <app-sidebar-element *ngIf="accountManagerService.isAdmin()" [collapsed]="collapsedSidebar" title="Personnel" icon="person" [selected]="isSelected('personnel')" (click)="goToPage('personnel')"></app-sidebar-element>
    <app-sidebar-element *ngIf="accountManagerService.isAdmin()" [collapsed]="collapsedSidebar" title="Skills" icon="verified" [selected]="isSelected('skill')" (click)="goToPage('skill')"></app-sidebar-element>
    <app-sidebar-element *ngIf="accountManagerService.isAdminOrExpert()" [collapsed]="collapsedSidebar" title="Maintenances" icon="double_arrow" [selected]="isSelected('maintenance')" (click)="goToPage('maintenance')"></app-sidebar-element>
    <app-sidebar-element *ngIf="accountManagerService.isAdminOrExpert()" [collapsed]="collapsedSidebar" title="Calendar" icon="calendar_today" [selected]="isSelected('calendar')" (click)="goToPage('calendar')"></app-sidebar-element>
    <app-sidebar-element *ngIf="accountManagerService.isAdminOrExpert() && settingsManagerService.hasCartographicConsole" [collapsed]="collapsedSidebar" title="Cartographic console" icon="travel_explore" [selected]="isSelected('cartographic-console')" (click)="goToPage('cartographic-console')"></app-sidebar-element>
    <app-sidebar-element *ngIf="accountManagerService.isAdmin()" [collapsed]="collapsedSidebar"title="Settings" icon="settings" [selected]="isSelected('settings')" (click)="goToPage('settings')"></app-sidebar-element>
    <!--<app-sidebar-element [collapsed]="collapsedSidebar" title="Chat" icon="chat_bubble_outline" [selected]="isSelected('chat')" (click)="goToPage('chat')"></app-sidebar-element>-->

    <!-- Settings and logout -->
    <div class="bottom-sidebar">
      <div class="expanded-list">

        <!-- Version info -->
        <span class="version">{{ 'Version' | translate }}: {{ version }}{{ environment.production ? '' : '-dev' }}</span>

        <!-- by Wideverse -->
        <img *ngIf="environment.showByWideverseWatermark" class="byWideverse" src="assets/img/byWideverse.png" alt="Wideverse">

        <button *ngIf="showPrivacyPolicy" mat-flat-button disableRipple [routerLink]="'/privacy'">{{ 'Privacy policy' | translate }}</button>
        <button mat-flat-button disableRipple (click)="logout()">{{ 'Logout' | translate }}</button>
      </div>
      <div class="collapsed-list" style="display: none">
        <app-sidebar-element [collapsed]="true" icon="verified_user" [selected]="isSelected('privacy')" (click)="goToPage('privacy')"></app-sidebar-element>
        <app-sidebar-element [collapsed]="true" icon="logout" (click)="logout()"></app-sidebar-element>
      </div>
    </div>

  </mat-drawer>

  <!-- Content -->
  <mat-drawer-content [class.collapsed]="collapsedSidebar && sidebar.opened">
    <router-outlet></router-outlet>
  </mat-drawer-content>

</mat-drawer-container>
